import TargetsWebComponent from './component/TargetsWebComponent';
import { WEB_COMPONENT_TARGETS } from '../webcomponents.constants';

export { TargetsWebComponent };

window.customElements.define(WEB_COMPONENT_TARGETS, TargetsWebComponent);
